import styled from "@emotion/styled";
import { Paragraph } from "@polestar/component-warehouse-react";
import React from "react";
import getCombinedOpeningHours from "../../../helpers/get-combined-opening-hours/getCombinedOpeningHours";
const StyledSpan = styled.span `
  display: block;
`;
const OpeningHours = ({ weekdays, closedLabel, open24hLabel, openingHours, }) => {
    let combinedOpeningHours = [];
    if (openingHours) {
        // map provided day labels to opening time entries
        const daysWithLabel = openingHours.map((entry, index) => {
            return { ...entry, dayRange: [weekdays[index]] };
        });
        combinedOpeningHours = getCombinedOpeningHours(daysWithLabel);
    }
    const getOpeningTime = (isClosedAllDay, isOpenAllDay, opensAt, closesAt) => {
        if (opensAt && closesAt) {
            return `${opensAt} - ${closesAt}`;
        }
        if (isClosedAllDay) {
            return closedLabel;
        }
        if (isOpenAllDay) {
            return open24hLabel;
        }
    };
    return combinedOpeningHours.length > 0 ? (React.createElement(Paragraph, null, combinedOpeningHours.map(({ dayRange, opensAt, closesAt, isClosedAllDay, isOpenAllDay, separator = " - ", }, index) => (React.createElement(StyledSpan, { key: `span-${index}` },
        dayRange.join(separator),
        " ",
        getOpeningTime(isClosedAllDay, isOpenAllDay, opensAt, closesAt)))))) : null;
};
export default OpeningHours;
